"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LayoutModule = _interopRequireDefault(require("../../Module/LayoutModule"));

var _PrimusPreviewModule = _interopRequireDefault(require("./PrimusPreviewModule"));

var _PrimusModuleCondition = _interopRequireDefault(require("./PrimusModuleCondition"));

var _PrimusModuleDamage = _interopRequireDefault(require("./PrimusModuleDamage"));

var _PrimusModuleTask = _interopRequireDefault(require("./PrimusModuleTask"));

var _PrimusModuleWork = _interopRequireDefault(require("./PrimusModuleWork"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const PrimusModule = (_ref) => {
  let documentType = _ref.documentType,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["documentType", "children"]);

  if (documentType === "condition") {
    return _react.default.createElement(_PrimusModuleCondition.default, _extends({
      documentType: documentType
    }, props));
  }

  if (documentType === "damage") {
    return _react.default.createElement(_PrimusModuleDamage.default, _extends({
      documentType: documentType
    }, props));
  }

  if (documentType === "task") {
    return _react.default.createElement(_PrimusModuleTask.default, _extends({
      documentType: documentType
    }, props));
  }

  if (documentType === "work") {
    return _react.default.createElement(_PrimusModuleWork.default, _extends({
      documentType: documentType
    }, props));
  }

  const formContext = props.formContext;
  const primaryAction = formContext.primaryAction && formContext.primaryAction.type && formContext.primaryAction.type;

  if (primaryAction === "edit" || primaryAction === "view") {
    return _react.default.createElement(_PrimusPreviewModule.default, props, children);
  }

  return _react.default.createElement(_LayoutModule.default, props, children);
};

var _default = PrimusModule;
exports.default = _default;
module.exports = exports.default;